import {HeaderDetails, Obligor} from "../pro-report/HeaderDetails";
import {FilterState} from "./filter-state";

export class ObligorState {
  obligor: Obligor;
  generatedTime: Date;
  lastEditedTime: Date;
  includeNews: boolean;
  headerDetails: HeaderDetails;
  filterState: FilterState = new FilterState();

  constructor(obligor: Obligor, headerDetails: HeaderDetails, includeNews: boolean, filterState: FilterState, generatedTime: Date, lastEditedTime: Date) {
    this.obligor = obligor;
    this.headerDetails = headerDetails;
    this.filterState = filterState;
    this.includeNews = includeNews;
    this.generatedTime = generatedTime;
    this.lastEditedTime = lastEditedTime;
  }

}
